import React from 'react';
import { isEmpty } from 'ramda';
import { Spin } from 'antd';
import { asyncConnect } from 'react-async-client';

import { getAuthToken } from 'utils/token';
import { getUser, getCompanyInfo } from 'actions/asyncActions';

import UserLayout from './user/UserLayout';
import GuestLayout from './guest/GuestLayout';

const mapStateToProps = ({ leftMenu: { leftMenuPinned } }) => {
    return { leftMenuPinned };
};

const SecureLayout = ({ getUser: { data, meta }, ...props }) => {
    const hasToken = getAuthToken();
    const isAuthenticated = !isEmpty(data) || meta.pending;
    const isSSO = (props.getCompanyInfo.data || {}).sso;

    return isAuthenticated ? (
        <Spin spinning={meta.pending}>
            <UserLayout {...props} user={data} />
        </Spin>
    ) : (
        (!hasToken || isSSO) ? <GuestLayout {...props} /> : null
    );
};

export default asyncConnect({
    getUser,
    getCompanyInfo: getCompanyInfo
        .withOptions({ dispatchOnMount: true })
}, mapStateToProps)(SecureLayout);
